import { vsingleton } from '@niknevis/vue-modules'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'

@vsingleton()
export default class WebRoute {

  home() {
    return Ziggy.url()
  }
}